"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  importCargoInfo: {
    title: '进口货物信息查询',
    blNo: '提单号',
    containerNo: '箱号',
    tips_1: '温馨提示：',
    tips_2: '（1） 进口可换单时间、费用信息仅供参考，实际以邮件和传真等书面通知为准。',
    tips_3: '（2） 滞期费免费天数查询结果仅供参考。',
    cargoInfo: '到货信息',
    baseInfo: '基本信息',
    containerInfo: '集装箱信息',
    vesselName: '船名：',
    voyageNo: '航次：',
    pol: '装港：',
    pod: '卸港：',
    eta: 'ETA预计到港时间：',
    actualEndTime: '码头预计完成作业：',
    releaseStatus: '放单状态：',
    changeStatus: '换单状态：',
    takeContainer: '提重箱场地：',
    rate: '本月美元兑港元汇率：',
    containerType: '箱型尺寸',
    quantity: '件数',
    weight: '毛重',
    size: '体积',
    uploadDate: '卸船日期',
    demToDate: '提重免费截至',
    FreeDays: '免费天数',
    importFee: '进口费用',
    chargeCode: '费用名称',
    amount: '金额',
    currency: '币种'
  },
  placeholder: {
    userName: '账号，用于网站登录（登陆账号注册后无法修改）',
    name: '您的姓名/昵称/联系人（可在个人中心进行修改）',
    password: '请输入密码',
    code: '请输入验证码',
    emailAddress: '邮箱用于用户激活账号，请确保邮箱地址能够正常使用',
    pol: '请输入起运港名称',
    pod: '请输入目的港名称',
    vesselName: '请输入船舶名称',
    blNo: '请输入提单号',
    containerNo: '请输入箱号',
    date: '选择日期',
    refNo: '请输入申请号',
    txtInfo: '请输入信息',
    vesselCode: '船名',
    voyageNo: '航次',
    voyageLeg: '航段',
    bkNo: '请输入订舱号'
  },
  validate: {
    userNameNotNull: '请输入账号',
    userNameISNull: '账号不为空',
    userNameExist: '账号已存在',
    userNameIsWrong: '账号不少于5位且不大于25位',
    nameIsNull: '姓名不能为空',
    containerNoIsFixed: '箱号只能11位',
    passwordNotNull: '请输入密码',
    passwordIsShort: '密码不能为空且不少于6位',
    passwordIsSimple: '必须包含大小写字母以及特殊字符',
    passwordNotTrue: '两次输入密码不一致',
    emailNotNull: '邮箱不能为空',
    authorizeCodeNotExist: '授权码不存在,请发送邮件至邮箱：cs-shipping@sitc.com 获取授权码',
    authorizeCodeNotNull: '授权码不为空,请发送邮件至邮箱：cs-shipping@sitc.com 获取授权码',
    emailNotTrue: '邮箱格式不正确！',
    code: '请输入验证码',
    pol: '起运港不能为空',
    pod: '目的港不能为空',
    vesselName: '船舶名称不能为空',
    blNo: ' 提单号不能为空! ',
    containerNo: ' 箱号不能为空! ',
    date: '起始日期不能为空',
    checkBlNo: '提单号/箱号有误！',
    inputNo: '输入不为空',
    refNo: '申请号不能为空',
    bkNo: '订舱号不能为空'
  },
  button: {
    search: '查询',
    reset: '重置',
    edit: '编辑',
    view: '查看',
    delete: '删除',
    save: '保存',
    saveCopy: '保存并拷贝',
    saveNew: '保存并新增',
    back: '返回',
    new: '新增',
    copy: '拷贝',
    excel: 'Excel导出',
    print: '打印',
    pdf: 'pdf导出',
    importExcel: '导入EXCEL',
    excelTemplate: 'EXCEL模板',
    sure: '确定',
    cancel: '取消'
  }
};